import React from "react";
import AuthForm from "../Components/AuthForm/AuthForm";

function Auth() {
  return (
    <>
      <AuthForm />
    </>
  );
}

export default Auth;
